import styled from '@emotion/styled'

import {NoStyleLink} from '@vio/atlas/src/components/designSystem/helpers/NoStyleLink'
import {cssTheme} from '@vio/atlas/src/themes'
import breakpoints, {Breakpoints} from '@vio/atlas/src/utils/breakpoints'

const MAX_ITEMS = 8

type Props = {
  links: {href: string; label: string}[]
}

const ListItem = styled.li`
  list-style: none;
  text-overflow: ellipsis;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
`

const List = styled.ul`
  display: grid;
  margin: 0;
  padding: 0;
  grid-gap: ${cssTheme.layout.spacing.s600} ${cssTheme.layout.spacing.s600};

  @media (max-width: ${breakpoints[Breakpoints.desktopXs]}px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: ${breakpoints[Breakpoints.desktopXs]}px) {
    grid-template-columns: repeat(4, 1fr);
  }
`

const StyledLink = styled(NoStyleLink)`
  ${cssTheme.typography.bodyS};

  &:hover {
    text-decoration: underline;
  }

  &:active {
    text-decoration: none;
  }
`

export const LinksList = ({links}: Props) => {
  return (
    <List>
      {links.slice(0, MAX_ITEMS).map(link => (
        <ListItem key={link.href}>
          <StyledLink href={link.href}>{link.label}</StyledLink>
        </ListItem>
      ))}
    </List>
  )
}
